import { useInfiniteQuery } from '@tanstack/react-query'
import { reactQueryKeys } from 'reactQueryKeys/reactQueryKeys'
import { getContactInstruments } from 'services/ContactService'
import { ContactPaymentInstrumentsResponse } from 'types/contacts'

export const useContactInstrumentsInfiniteQuery = (searchTerm = '') => {
  return useInfiniteQuery({
    queryKey: reactQueryKeys.contactPaymentInstruments(searchTerm),
    queryFn: ({ pageParam = 0 }) => getContactInstruments(searchTerm, 10, pageParam, ''),
    getNextPageParam: (lastPage: ContactPaymentInstrumentsResponse) => {
      return lastPage?.pageable?.pageNumber + 1 < lastPage?.totalPages
        ? lastPage?.pageable.pageNumber + 1
        : undefined
    },
    initialPageParam: 0,
    select: data => {
      const contactInstruments = data?.pages?.flatMap(page => page?.content)
      return contactInstruments
    },
  })
}
